export const DEFAULT_TABLE_HEIGHT = 350;
export const MIN_TABLE_HEIGHT = 160;
export const TABLE_HEADER_HEIGHT = 82;
